import { State } from '@/stores/orders/state';
import { Actions } from '@/stores/orders/actions';
import { Getters } from '@/stores/orders/getters';
import { Mutations } from '@/stores/orders/mutations';
import { Module } from 'vuex';

export class OrderStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
